<template>
    <div>
        <stick-pop v-bind="$attrs" @click="show">
            <el-icon name="delete"></el-icon>
        </stick-pop>
        <my-dialog ref="dialog" title="清理缓存" :hide-callback="closeDialogCallback">
            <div align="center" class="margin-top-20px font-gray">当前应用缓存占用 <span class="font-black">{{size}}</span>, 是否清理？</div>
            <div class="margin-top-30px">
                <el-button type="danger" @click="free">确定</el-button>
                <el-button @click="hide">取消</el-button>
            </div>
        </my-dialog>
    </div>
</template>

<script>
    import StickPop from "./StickPop";
    import MyDialog from "../MyDialog";
    import {isHybridAgent, Styles} from "../../../utils";
    import {utils} from "@shangyang/utils";

    // 由 https://www.html5plus.org/doc/zh_cn/downloader.html#plus.downloader.DownloadOptions 可知，h5plus 可用的缓存目录仅为如下三个
    const tempDirs = ["_downloads/", "_doc/", "_documents/"];

    export default {
        name: "TrashBin",
        components: {StickPop, MyDialog},
        data (){
            return {
                size: '0 K字节'
            }
        },
        methods: {
            show(){
                if(isHybridAgent()){
                    // plus.device.vibrate();
                    this.calc();
                }
            },
            reset(){
                this.size = '0KB';
            },
            calc(){
                var w = plus.nativeUI.showWaiting("缓存计算中...");
                let done = 0 //  分别对应三个目录的状态，当 done 的累加值登录 doneComplete 即 3 的时候表示执行结束。
                let doneComplete = 3;
                let fileSize = 0
                // 迭代计算每一个临时目录中的文件大小。
                for (let dir of tempDirs){
                    plus.io.resolveLocalFileSystemURL(
                        dir,  // the target dir to calc
                        function(entry) { // success callback 通过 URL 参数获取目录对象或文件对象
                            var directoryReader = entry.createReader();
                            directoryReader.readEntries(
                                function(entries) { // success callback 获取当前目录中的所有文件和子目录
                                    for(var i = 0; i < entries.length; i++) {
                                        if(entries[i].isFile) {
                                            entries[i].file(function(file) {
                                                fileSize += (file.size * 0.0009766); // 1字节=0.0009766kb
                                            }, function(e) {
                                                console.error(e.message);
                                            });
                                        } else {
                                            entries[i].getMetadata(function(metadata) {
                                                fileSize += (metadata.size * 0.0009766); // 1字节=0.0009766kb
                                            }, function(e) {
                                                console.error(e.message);
                                            });
                                        }
                                    }
                                    done ++;
                                },
                                function(e) { // error callback
                                    console.error('文件读取失败');
                                    done ++;
                                }
                            );
                        },
                        function(e) { // error callback
                            console.error('文件路径读取失败');
                            done++;
                        }
                    );
                }
                // interval 的去检测是否检查完毕
                let intl = setInterval(function() {
                    this.size = utils.bytes2HumanReadable(Math.ceil(fileSize) * 1024) // 它是以 K 开始的，而 utils.bytes2HumanReadable 是以 B 为单位的
                    if (done === doneComplete){  // 缓存检查结束入口
                        console.log(`calc cache completed, and the cache file takes ${this.size}`);
                        window.clearInterval(intl);
                        setTimeout(()=>{
                            plus.nativeUI.closeWaiting();
                            this.showDialog();
                        }, 300);
                    }else{
                        console.log('cache file takes ' + this.size);
                    }
                }.bind(this), 300);
            },
            free(){
                this.hide();
                var w = plus.nativeUI.showWaiting("缓存清理中...");
                let done = 0;
                let doneComplete = 3;
                for (let dir of tempDirs){
                    plus.io.resolveLocalFileSystemURL(dir, function(entry) {
                        entry.removeRecursively(function(entry) { //递归删除其下的所有文件及子目录
                            console.log(`${dir}目录缓存清理完成`);
                            done ++
                        }, function(e) {
                            console.error(e.message);
                            done ++
                        });
                    }, function(e) {
                        console.error('文件路径读取失败');
                        done ++
                    });
                }
                // interval 的去检测是否清理完毕
                let intl = setInterval(function() {
                    if (done === doneComplete){  // 缓存检查结束入口
                        console.log('cache get cleared up completed');
                        window.clearInterval(intl);
                        setTimeout(()=>{
                            plus.nativeUI.closeWaiting();
                            plus.nativeUI.alert('缓存已清理完毕');
                            this.reset();
                        }, 300);
                    } else {
                        console.log('cache file takes ' + this.size);
                    }
                }.bind(this), 300);
            },
            showDialog(){
                this.$refs.dialog.show();
                Styles.disableBodyScroll();
            },
            hide(){
                this.$refs.dialog.hide();
            },
            closeDialogCallback() {
                Styles.enableBodyScroll();
            }
        }
    }
</script>

<style scoped>
    /deep/ .dialog-content-panel {
        height: 120px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/stickpops/TrashBin.vue